<section class="categories-section">
  <div class="categories-grid">
    @for (category of categories; track category.title) {
      <a [href]="category.href" class="category-card">
        <div class="card-overlay"></div>
        <div class="card-title">
          <h3>{{ category.title }}</h3>
        </div>
        <div class="card-image">
          <img [src]="category.image" [alt]="category.title" />
        </div>
      </a>
    }
  </div>
</section>
